import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { theme } from '~/styles'

interface IField {
  large?: boolean
  disable?: boolean
  error?: boolean
  active?: boolean
}

interface MessageStyles {
  error?: boolean
}

interface Input {
  error?: boolean | string
  active?: boolean | string
  direction?: string
}

const stateInput = {
  error: css`
    color: ${theme.colors.color6b7786};

    svg {
      fill: ${theme.colors.colorFF2424};
    }
  `,
  active: css`
    -webkit-box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
    -moz-box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
    box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
  `
}

const stateMessage = {
  error: css`
    color: ${theme.colors.colorFF2424};
  `
}

export const WrapperLight = styled.div<Input>`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: ${props => props.direction};
  align-items: center;
  border-radius: ${({ theme }) => theme.zds.border.radius100};

  svg {
    fill: transparent;
    position: absolute;
    right: 10px;
  }
  ${({ active }) => (active ? stateInput.active : null)};
  ${({ error }) => (error ? stateInput.error : null)}
`

export const Message = styled.span<MessageStyles>`
  display: block;
  color: transparent;
  font-size: 12px;
  padding-top: 4px;
  position: absolute;
  bottom: -18px;
  left: 2px;

  ${({ error }) => (error ? stateMessage.error : null)};
`

export const Container = styled.div`
  display: flex;
  position: relative;
  flex: 1;
`

export const ErrorTextAreaIcon = styled.div`
  margin-bottom: 18px;
  align-self: flex-end;
`

export const Field = styled.textarea<IField>`
  flex: 1;
  padding: 8px 16px;
  resize: none;
  outline: none;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  border: 1px solid ${theme.colors.colorBCC9D9};
  min-height: ${props => (!props.large ? '89px' : '161px')};
  display: flex;
  flex-wrap: wrap;
  font-family: 'Inter', sans-serif;
  ${props =>
    props.disable &&
    css`
      background: ${props.theme.colors.colore9ecf3};
      border: 1px solid ${props.theme.colors.colord4d9de};
      pointer-events: none;
    `}

  ${props =>
    props.error &&
    css`
      border: 1px solid ${theme.colors.colorFF2424};
    `}
  ${props =>
    !props.error &&
    props.active &&
    css`
      border: 1px solid ${theme.colors.color378ff7};
    `}

  &::placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }

  &::-ms-input-placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }

  &::-ms-input-placeholder {
    color: ${theme.colors.color6b7786};
    opacity: 0.5;
  }
`
